// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__WX_8A","col":"styles_col__191Nb"};